import { motion } from "framer-motion";
import { FOUNDERS } from "../lib/data";

const PORTRAITS = [
  "/images/founder1.jpeg",
  "/images/founder2.jpeg",
  "/images/founder3.jpeg",
  "/images/founder4.jpeg",
  "/images/founder5.png",
];

export default function Founders() {
  return (
    <section id="founders" data-testid="founders-section" className="px-6 md:px-12 py-24 md:py-32 bg-alt border-y border-soft">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 mb-16 md:mb-20 items-end">
          <div className="md:col-span-7">
            <div className="overline mb-5" data-testid="founders-overline">Who we are</div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-[3.5rem] leading-[1.05] tracking-tight text-strong font-medium">
              Built by people who have <span className="serif-italic text-accent">lived</span> silicon failure.
            </h2>
          </div>
          <p className="md:col-span-5 text-base md:text-lg text-muted leading-relaxed">
            Five co-founders. Ninety-plus combined years at Synopsys, Intel, AMD, NVIDIA, Apple, Google, Marvell.
            We have shipped chips, missed tapeouts, and seen exactly where execution breaks.
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 md:gap-8 items-start">
          {FOUNDERS.map((f, i) => (
            <motion.figure
              key={f.name}
              data-testid={`founder-${i}`}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.7, delay: i * 0.06, ease: [0.16, 1, 0.3, 1] }}
              className="flex flex-col gap-4 group"
            >
              <div className="aspect-[3/4] overflow-hidden rounded-xl surface w-full">
                <img
                  src={PORTRAITS[i]}
                  alt={f.name}
                  loading="lazy"
                  className="w-full h-full object-cover object-center grayscale group-hover:grayscale-0 transition-all duration-700 ease-out scale-[1.02] group-hover:scale-[1.04]"
                />
              </div>
              <figcaption>
                <div className="font-display text-[1.15rem] text-strong leading-tight font-medium">{f.name}</div>
                <div className="text-[0.72rem] uppercase tracking-[0.16em] text-accent font-medium mt-1">{f.role}</div>
                <div className="text-[13px] text-muted mt-2 leading-snug">{f.prior}</div>
                <div className="text-[12px] text-faint mt-1">{f.years}</div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
